import ApplicationSummaryContainer from './ApplicationSummaryContainer';

export default ApplicationSummaryContainer;
